import { useEffect, useState } from "react";

import { SubmitHandler } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

import { signInWithEmailAndPassword } from "firebase/auth";

import useAuth from "../../hooks/useAuth";
import Barney from "../../assets/barney.png";
import { Alert } from "../../components/base/Alert";
import { Button } from "../../components/base/Button";
import Form from "../../components/base/Form/Form";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { FormErrors } from "../../components/base/Form/FormErrors";
import { FormTextField } from "../../components/base/Form/FormTextField";
// import usePasswordRecovery from "../../data/usePasswordRecovery";

interface LoginFormFields {
  email: string;
  password: string;
}

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const { auth, user, loading } = useAuth();
  const [error, setError] = useState<string>("");

  const doLogin: SubmitHandler<LoginFormFields> = async (data) => {
    try {
      await signInWithEmailAndPassword(auth, data.email, data.password);
    } catch (err: any) {
      let errorStr = `Unknown error occurred: ${err.code}`;

      if (err.code === "auth/user-not-found") {
        errorStr = "Email address does not match an account!";
      } else if (
        err.code === "auth/wrong-password" ||
        err.code === "auth/invalid-credential"
      ) {
        errorStr = "Password is incorrect, please try again.";
      } else if (err.code === "auth/too-many-requests") {
        errorStr =
          "Please Wait! You have tried to login too many times recently.";
      }

      setError(errorStr);
    }
  };

  // const passwordReset = () => {
  //   sendPasswordReset.mutate(email, {
  //     onSuccess: () => {
  //       setError("Password reset has been requested, please check your inbox.");
  //     },
  //     onError: () => {
  //       setError(
  //         "Password reset failed, you may have requested too many resets! Please try again shortly or contact support."
  //       );
  //     },
  //   });
  // };

  useEffect(() => {
    if (user) navigate(from, { replace: true });
  }, [user, navigate, from]);

  return (
    <>
      <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex flex-shrink-0 justify-center items-center px-4 text-black">
            <img className="h-20 w-auto" src={Barney} alt="Barney Logo" />
            <div className="flex flex-col items-center font-stick text-2xl">
              <p>Barney</p>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mb-32 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            {loading ? (
              <LoadingWheel />
            ) : (
              <>
                <h2 className="mb-6 text-2xl font-bold tracking-tight font-stick text-gray-900">
                  Sign in
                </h2>
                <Form<LoginFormFields> className="space-y-6" onSubmit={doLogin}>
                  {({ register }) => (
                    <>
                      <FormErrors />
                      {error && (
                        <Alert
                          severity="error"
                          title="Authentication Error"
                          message={error}
                        />
                      )}
                      <FormTextField
                        {...register("email", { required: true })}
                        label="Email Address"
                        placeholder="joe.bloggs@email.com"
                      />
                      <FormTextField
                        {...register("password", { required: true })}
                        type="password"
                        label="Password"
                        placeholder="Password"
                      />
                      <Button fullWidth type="submit">
                        Sign in
                      </Button>

                      {/* <div className="text-sm">
                        <a
                          href="#"
                          className="font-medium text-orange-600 hover:text-orange-500"
                          onClick={(x) => passwordReset()}
                        >
                          Forgot your password?
                        </a>
                      </div> */}
                    </>
                  )}
                </Form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
